import { inject } from 'aurelia-framework';
import numeral from 'numeral';
import { AuthService } from '../services/authService';

@inject(AuthService)

export class CurrencyFormatValueConverter {
  constructor(authService) {
    this.authService = authService;
    this.userData =  {} ;
}
  currencyCheck() {
     
  }
  toView(value) {
        if(this.authService.user) {
         this.userData = this.authService.getUser();
         console.log("user data in currencyformat",this.userData);
        //  var account = this.userData.hasOwnProperty("whitelabel") ?  this.testData.whitelabel : null; 
         var jsonData = this.userData.hasOwnProperty("payment_int_data") ?  this.userData.payment_int_data : null; 
         var jsonPayment = JSON.parse(jsonData);
         var currency;
         if(jsonPayment) {
          currency = jsonPayment.hasOwnProperty("currencyCode") ?  jsonPayment.currencyCode : null;
         }

         switch (currency) {
          case "cad":
            console.log("currency case...cad",currency);
            return 'C$' +  numeral(value).format('0,0.00');
            break;
          case "usd":
              console.log("currency case...usd",currency);
              return '$' + numeral(value).format('0,0.00');
            break;
          case "gbp":
              console.log("currency case...gbp",currency);
              return '£' +  numeral(value).format('0,0.00');
            break;
          default:
              console.log("currency case...usd",currency);
              return '$' + numeral(value).format('0,0.00');
        }
      }

     return numeral(value).format('($0,0.00)');
  }
}

